import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes as ReactRouterRoutes, Route, Navigate } from 'react-router-dom';
import { routes, RouteType } from '../constants/routes';
import ProtectedRoute from './protectedRoute';
import NotFoundPage from '../pages/common/NotFoundPage';
import ErrorPage from '../pages/common/ErrorPage';
import { useAuth } from '@/contexts/AuthContext';
import Spinner from '@/components/ui/Spinner';

/**
 * AppRoutes é o componente principal de roteamento da aplicação TugasCoins.
 * Ele utiliza o React Router DOM para definir e gerenciar todas as rotas,
 * incluindo rotas públicas e protegidas por autenticação e papéis de usuário.
 *
 * O design é focado na clareza e manutenibilidade, utilizando um array centralizado
 * de definições de rota (routes.ts) e um componente ProtectedRoute para encapsular
 * a lógica de autorização, garantindo uma UX/UI impecável ao direcionar o usuário
 * para as páginas corretas com base em seu estado de autenticação e permissões.
 */
const AppRoutes: React.FC = () => {
  const rotas = routes();
  const usuario = useAuth();
  const [carregando, setCarregando] = useState(false);

  // ✅ useEffect is now correctly placed INSIDE the component
  useEffect(() => {
    // Your effect logic here
    setCarregando(true);
    if (window.location.pathname === '/cadastro' && usuario.usuario) {
      window.location.href = '/';
    }
    setCarregando(false);
  }, [rotas, usuario.usuario]);

  return (
    <BrowserRouter>
      <ReactRouterRoutes>
        {rotas.map((route: RouteType, index: number) => {
          // Renderiza rotas que não possuem um papel definido ou são explicitamente públicas.
          // A lógica de proteção é aplicada se 'route.role' estiver presente.
          if (route.role !== null) {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <ProtectedRoute allowedRoles={route.role}>
                    {route.element}
                  </ProtectedRoute>
                }
              />
            );
          }
          // Rotas públicas que não precisam de proteção
          return (
            <Route
              key={index}
              path={route.path}
              element={route.element}
            />
          );
        })}

        {carregando ? (<>
          <div className="flex items-center justify-center min-h-screen bg-background">
            <Spinner size="lg" color="primary" />
          </div>
        </>
        ) : (
          <>
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="/erro" element={<ErrorPage />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </>

        )};


      </ReactRouterRoutes>
    </BrowserRouter>
  );
};

export default AppRoutes;